<!-- src/app/shared/components/delegation-dropdown/delegation-dropdown.component.html -->
<div class="delegation-dropdown" *ngIf="isAuthenticated && availableDelegations?.length">
  <div ngbDropdown class="dropdown">
    <button 
      ngbDropdownToggle
      class="btn dropdown-toggle"
      [class.btn-outline-primary]="!isDelegating"
      [class.btn-warning]="isDelegating"
      type="button">
      
      <!-- Icon -->
      <i class="fas fa-user-friends me-2"></i>
      
      <!-- Button text -->
      @if (!isDelegating) {
        <span tmwTranslate="tmw.delegation.switchUser">Changer d'utilisateur</span>
      } @else {
        <span class="text-dark">
          <span tmwTranslate="tmw.delegation.actingAs">Agir en tant que</span>: {{ currentDelegation?.delegatorName }}
        </span>      }
    </button>
    
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
      
      <!-- Return to original user option -->
      @if (isDelegating) {
        <a class="dropdown-item" 
           href="#" 
           (click)="switchBackToOriginal(); $event.preventDefault()">
          <i class="fas fa-undo text-success me-2"></i>
           <p class="mb-0 fs-sm text-muted" tmwTranslate="tmw.delegation.returnDescription">
                Reprendre votre identité normale
            </p>
        </a>
        <div class="dropdown-divider"></div>
      }
      
      <!-- Available delegations with @empty fallback -->
      @for (delegation of availableDelegations; track delegation.delegationId) {
        <a class="dropdown-item" 
           href="#" 
           (click)="switchToDelegation(delegation); $event.preventDefault()"
           [class.active]="isCurrentDelegation(delegation)">
          
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="fw-bold">{{ delegation.delegatorName }}</div>
              <small class="text-muted">{{ delegation.delegatorLogin }}</small>
            </div>
            <div class="text-end">
              <small class="text-muted" tmwTranslate="tmw.delegation.expiresAt" >
                Expire le: {{ delegation.dateFin | date:'short' }}
              </small>
              @if (isCurrentDelegation(delegation)) {
                <div class="text-success">
                  <i class="fas fa-check-circle"></i> Active
                </div>
              }
            </div>
          </div>
        </a>
      } @empty {
        <span >empty</span>
      }
      
    </div>
  </div>
</div>